import {
  FinishCreateCommodity,
  FinishGetCommodities,
  FinishGetUnitOfMeasurement,
  InitCreateCommodity,
  InitGetCommodities,
  InitGetUnitOfMeasurement,
} from '@core/state/commodity/commodity.actions';
import { createReducer, on } from '@ngrx/store';

export interface CommodityState {
  loadingCommoditiesForm: boolean;
  loadingGetCommodities: boolean;
  loadingUnitOfMeasurement: boolean;
  loadingCreateCommodity: boolean;
}

export const initialCommodityState: CommodityState = {
  loadingCommoditiesForm: false,
  loadingGetCommodities: false,
  loadingUnitOfMeasurement: false,
  loadingCreateCommodity: false,
};

export const commodityReducer = createReducer(
  initialCommodityState,
  on(InitGetCommodities, (state) => {
    return {
      ...state,
      loadingGetCommodities: true,
    };
  }),
  on(FinishGetCommodities, (state) => {
    return {
      ...state,
      loadingGetCommodities: false,
    };
  }),
  on(InitCreateCommodity, (state) => {
    return {
      ...state,
      loadingCreateCommodity: true,
    };
  }),
  on(FinishCreateCommodity, (state) => {
    return {
      ...state,
      loadingCreateCommodity: false,
    };
  }),
  on(InitGetUnitOfMeasurement, (state) => {
    return {
      ...state,
      loadingUnitOfMeasurement: true,
    };
  }),
  on(FinishGetUnitOfMeasurement, (state) => {
    return {
      ...state,
      loadingUnitOfMeasurement: false,
    };
  })
);
